import './bookmark.scss';
import { createElementFromHTML } from '../../utilities/js/helper';

class Bookmark {
    constructor () {
        this.localStorage = [];
        this.localBookmarks = [];
        this.$mainBookmarksLabel = document.querySelector('[data-main-bookmarks]');
        this.$mainBookmarksList = document.querySelector('[data-main-bookmarks="list"]');
        this.$mainBookmarksCount = document.querySelector('[data-main-bookmarks-count]');
        this.$mainBookmarksPreviewList = document.querySelector('[data-main-bookmarks="preview-list"]');
        this.$mainBookmarksPreviewCount = document.querySelector('[data-main-bookmarks-preview-count]');
    }

    initialize ($content) {
        this.readStorage();

        const $bookmarks = $content.querySelectorAll('[data-bookmark]');

        if ($bookmarks.length > 0) {
            $bookmarks.forEach((bookmark) => {
                this.setEvent(bookmark);

                if (this.localBookmarks && this.localBookmarks.length > 0) {
                    if (this.checkBookmark(bookmark.dataset.bookmarkTripcode)) {
                        bookmark.classList.add('is--bookmarked');
                    }
                }
            });
        }

        this.createList();
        this.createCount();
    }

    // set general events
    setEvent (bookmarkButton) {
        bookmarkButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (bookmarkButton.classList.contains('is--bookmarked')) {
                this.removeBookmark(bookmarkButton.dataset.bookmarkTripcode);
                bookmarkButton.classList.remove('is--bookmarked');
            } else {
                this.setBookmark(bookmarkButton);
                bookmarkButton.classList.add('is--bookmarked');
            }
        });
    }

    createList () {
        if (this.localBookmarks && this.localBookmarks.length > 0) {
            if (this.$mainBookmarksList && this.$mainBookmarksPreviewList) {
                this.$mainBookmarksList.innerHTML = '';
                this.$mainBookmarksPreviewList.innerHTML = '';

                this.localBookmarks.slice().reverse().forEach(bookmark => {
                    const travelIsPreview = bookmark.travelPreview !== undefined && bookmark.travelPreview === 'true';
                    const linkStartTag = travelIsPreview === false ? '<a href="' + bookmark.url + '"' : '<div ';
                    const linkEndTag = travelIsPreview === false ? '</a>' : '</div>';

                    const $bookmark = createElementFromHTML('' +
                        '<li class="main-nav__bookmarks-item">' +
                        linkStartTag + 'class="main-nav__bookmarks-link">' +
                        '<figure class="main-nav__bookmarks-image">' +
                        '<img src="' + bookmark.image + '" alt="dummy Image">' +
                        '</figure>' +
                        '<div class="main-nav__bookmarks-content">' +
                        '<p class="main-nav__bookmarks-route">' + bookmark.route + '</p>' +
                        '<p class="main-nav__bookmarks-title">' + bookmark.title + '</p>' +
                        '</div>' +
                        '<div class="main-nav__bookmarks-hover">' +
                        '<div type="button" class="button reverse-icon">' + translations.bookmarksLinkToTripLabel + '<svg aria-hidden="true" role="none" width="24" height="24" class="icon icon--is-arrow-right"><use xlink:href="#icon-arrow-right"></use></svg></div>' + // eslint-disable-line
                        '</div>' + linkEndTag + '</li>');

                    if (travelIsPreview) {
                        if (this.$mainBookmarksPreviewList.childNodes.length < 3) {
                            this.$mainBookmarksPreviewList.prepend($bookmark);
                        }
                    } else {
                        if (this.$mainBookmarksList.childNodes.length < 3) {
                            this.$mainBookmarksList.prepend($bookmark);
                        }
                    }
                });
            }
        } else {
            if (this.$mainBookmarksList && this.$mainBookmarksPreviewList) {
                this.$mainBookmarksList.innerHTML = '';
                this.$mainBookmarksPreviewList.innerHTML = '';
            }
        }
    }

    setCount (count, $countContainer, travelPreview = false) {
        if (this.$mainBookmarksLabel && $countContainer) {
            if (this.localBookmarks && this.localBookmarks.length > 0) {
                this.$mainBookmarksLabel.setAttribute('data-main-bookmarks', this.localBookmarks.length);
            } else {
                this.$mainBookmarksLabel.setAttribute('data-main-bookmarks', 0);
            }

            const $lastChildFromLabel = this.$mainBookmarksLabel.lastElementChild;
            const $firstChildFromCountContainer = $countContainer.firstElementChild;

            $countContainer.setAttribute('data-main-bookmark-active', count === 0 ? 'false' : 'true');

            if ($lastChildFromLabel) {
                $lastChildFromLabel.textContent = count.toString();
            }

            if ($firstChildFromCountContainer) {
                $firstChildFromCountContainer.textContent = `${count.toString()} ${(parseInt(count) > 1) ? (travelPreview ? translations.bookmark.preview : '') + ' ' + translations.bookmark.trips : (travelPreview ? translations.bookmark.preview : '') + ' ' + translations.bookmark.trip}`; // eslint-disable-line
            }
        }
    }

    createCount () {
        const bookmarks = [];
        const previewBookmarks = [];

        if (this.localBookmarks && this.localBookmarks.length > 0) {
            this.localBookmarks.forEach(localBookmark => {
                if (localBookmark.travelPreview !== undefined && localBookmark.travelPreview === 'true') {
                    if (!previewBookmarks.includes(localBookmark.tripCode)) {
                        previewBookmarks.push(localBookmark.tripCode);
                    }
                } else {
                    if (!bookmarks.includes(localBookmark.tripCode)) {
                        bookmarks.push(localBookmark.tripCode);
                    }
                }
            });

            this.setCount(previewBookmarks.length, this.$mainBookmarksPreviewCount, true);
            this.setCount(bookmarks.length, this.$mainBookmarksCount);
        } else {
            this.setCount(0, this.$mainBookmarksPreviewCount, true);
            this.setCount(0, this.$mainBookmarksCount);
        }
    }

    readStorage () {
        this.localBookmarks = JSON.parse(localStorage.getItem('bookmarks'));
    }

    setBookmark (bookmark, object) {
        let bookmarkObject = {};

        if (!object) {
            bookmarkObject = {
                route: bookmark.dataset.bookmarkRoute,
                title: bookmark.dataset.bookmarkTitle,
                url: bookmark.dataset.bookmarkUrl,
                tripCode: bookmark.dataset.bookmarkTripcode,
                image: bookmark.dataset.bookmarkImage,
                travelPreview: bookmark.dataset.bookmarkTravelPreview
            };
        } else {
            bookmarkObject = object;
        }

        const $bookmarks = JSON.parse(localStorage.getItem('bookmarks')) || [];

        $bookmarks.push(bookmarkObject);
        localStorage.setItem('bookmarks', JSON.stringify($bookmarks));
        this.localBookmarks = $bookmarks;

        this.createList();
        this.createCount();
    }

    removeBookmark (tripCode) {
        const newArr = [];
        this.readStorage();

        for (const bookmark of this.localBookmarks) {
            if (bookmark.tripCode !== tripCode) {
                newArr.push(bookmark);
            }
        }

        localStorage.setItem('bookmarks', JSON.stringify(newArr));
        this.localBookmarks = newArr;

        window.dispatchEvent(new CustomEvent('bookmark.removed', {
            view: window,
            bubbles: true,
            cancelable: false
        }));

        this.createList();
        this.createCount();
    }

    checkBookmark (tripCode) {
        return this.localBookmarks.some(function (bookmark) {
            return bookmark.tripCode === tripCode;
        });
    }

    clearBookmarks () {
        localStorage.removeItem('bookmarks');
    }
}

export { Bookmark };
